import type { ComponentProps } from 'react';

import BpkButton, { BUTTON_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-button';

import STYLES from './ThemeButton.module.scss';

type Props = ComponentProps<typeof BpkButton>;

export const ThemeButton = ({
  className = STYLES.button,
  type = BUTTON_TYPES.primaryOnDark,
  ...props
}: Props) => <BpkButton type={type} className={className} {...props} />;
